module.exports = __webpack_public_path__ + "img/md_logo.3a2b67d9.svg";